import { Base } from "./base";
import { Location } from "./location";
import { Product } from "./product";
import { PurchaseOrder } from "./purchase.order";
import { Shipment } from "./shipments";
import { Warehouse } from "./warehouse";

type DateString = Date | string;

export interface DespatchStatusOption {
  value: string;
  label: string;
}
export interface Despatch extends Base {
  status: string;
  pickupDate: string;
  deliveryDate: string;
  costCenter: string;
  deliveryInstructions: string;
  fleets?: DespatchTruck[];
  products?: DespatchProduct[];
  shippingItems?: DespatchShippingItem[];
  originAddress?: Location;
  destinationAddress?: Location;
  origins?: Location[];
  destinations?: Location[];
  externalUuid?: string;
}

export type DespatchProduct = {
  id?: number;
  status?: string;
  containerId?: string;
  productQuantity?: number;
  quantityOnHand?: number;
  palletsQuantity?: number;
  createdAt?: DateString;
  updatedAt?: DateString;
  companyId?: number;
  despatchId?: number;
  purchaseOrderId?: string;
  /**
   * reference to shipment_container > association name: container
   */
  productId: number;
  container?: DespatchShipmentContainer;
};

export interface DespatchShipmentContainer extends Base {
  containerId?: string;
  shipmentId: number;
  shipment?: Shipment;
  purchaseOrder?: string;
  cartonQty?: number;
  onHand?: number;
  arriveDc?: Date;
  productId: number;
  product?: Product;
  destinationStore?: string;
  warehouseId: number;
  warehouse?: Warehouse;
  projectId: number;
  comment?: string;
  actualDateDeparture?: Date;
  despatchesProducts?: DespatchProduct[];
  purchaseOrders?: PurchaseOrder[];
  quantityOnHand?: number;
}

export type DespatchTruck = {
  id: number;
  fleetType?: string;
  bookingNumber?: string;
  palletsPerFleet?: number;
  deliveryDate?: DateString;
  deliveryWindowOpen?: string;
  deliveryWindowClose?: string;
  companyId: number;
  despatchId: number;
  createdAt: string | Date;
  updatedAt: string | Date;

  uuid?: string; // used only web
};

export type DespatchShippingItem = {
  id: number;
  dispatchId: number;
  type?: string;
  description?: string;
  length?: string;
  width?: string;
  height?: string;
  weight?: string;
  volume?: number | string;
  companyId: number;
  createdAt: string | Date;
  updatedAt: string | Date;

  uuid?: string; // used only web
};

export enum DespatchShippingItemKeys {
  WEIGHT = "weight",
}
